import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { alignTypes, justifyTypes, spacingValue } from '../utils';

function flex(_ref) {
  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      alignItems = _ref2.alignItems,
      alignSelf = _ref2.alignSelf,
      basis = _ref2.basis,
      direction = _ref2.direction,
      flexBasis = _ref2.flexBasis,
      flexGrow = _ref2.flexGrow,
      flexShrink = _ref2.flexShrink,
      flexWrap = _ref2.flexWrap,
      grow = _ref2.grow,
      justifyContent = _ref2.justifyContent,
      shrink = _ref2.shrink,
      wrap = _ref2.wrap,
      styles = _objectWithoutPropertiesLoose(_ref2, ["alignItems", "alignSelf", "basis", "direction", "flexBasis", "flexGrow", "flexShrink", "flexWrap", "grow", "justifyContent", "shrink", "wrap"]);

  if (direction) {
    styles.flexDirection = direction;
  }

  if (typeof wrap === 'undefined') {
    wrap = flexWrap;
  }

  if (typeof wrap !== 'undefined') {
    styles.flexWrap = wrap === 'reverse' ? 'wrap-reverse' : wrap === true || wrap === 'wrap' ? 'wrap' : 'nowrap';
  }

  if (typeof grow === 'undefined') {
    grow = flexGrow;
  }

  if (typeof grow !== 'undefined') {
    styles.flexGrow = grow === true ? 1 : grow;
  }

  if (typeof shrink === 'undefined') {
    shrink = flexShrink;
  }

  if (typeof shrink !== 'undefined') {
    styles.flexShrink = shrink === true ? 1 : shrink;
  }

  if (typeof basis === 'undefined') {
    basis = flexBasis;
  }

  if (typeof basis !== 'undefined') {
    styles.flexBasis = spacingValue(basis);
  }

  if (justifyContent) {
    styles.justifyContent = justifyTypes[justifyContent] || justifyContent;
  }

  if (alignItems) {
    styles.alignItems = alignTypes[alignItems] || alignItems;
  }

  if (alignSelf) {
    styles.alignSelf = alignTypes[alignSelf] || alignSelf;
  }

  return styles;
}

export default flex;